
import React from 'react';
import Immutable from 'immutable';
import cn from 'classnames';
import _ from 'lodash';

import { alert, prompt, promptModal, promptConfirm } from '../../../../../../common/Modal';
import Icon from '../../../../../../common/UI/Icon';

import { checkAccessOnObject } from '../../../../../../../utils/rights';
import PRIVILEGE_CODES from '../../../../../../../configs/privilegeCodes';
import RESOURCE_TYPES from '../../../../../../../configs/resourceTypes';

import apiActions from '../../../../../../../actions/apiActions';
import sectionActions from '../../../../../../../actions/sectionActions';
import modalsActions from '../../../../../../../actions/modalsActions';
import { validateApiKey } from '../../../../../../../utils/validateApiKey';

import styles from './actions.less';

export function sectionItems(inGroup) {
    const { section, t } = this.props;
    const sectionId = section?.get('id');

    const isAdmin = checkAccessOnObject(RESOURCE_TYPES.SECTION, section, PRIVILEGE_CODES.ADMIN);
    const isAccess = checkAccessOnObject(RESOURCE_TYPES.SECTION, section, PRIVILEGE_CODES.ACCESS);

    let menu = [];

    // edit catalog
    if (isAdmin) {
        menu.push({
            key: 'sectionEdit',
            label: (
                <a onClick={this.sectionEdit}>
                    <Icon type="icon edition-33" className={styles.settingIcon} />
                    {t('buttons.renameSection')}
                </a>
            ),
        });
    }


    // access
    if (isAccess) {
        menu.push({
            key: 'sectionAccess',
            label: (
                <a onClick={this.sectionAccess}>
                    <Icon type="icon edition-55" className={cn(styles.settingIcon, styles.settingIconAccess)} />
                    {t('buttons.accessSection')}
                </a>
            ),
        });
    }


    // edit id
    /* if (isAdmin && !_.startsWith(sectionId, '$')) {
        menu.push({
            key: 'sectionSetId',
            label: (
                <a onClick={this.sectionSetId}>
                    <Icon type="icon edition-59" className={styles.settingIcon} />
                    {t('buttons.setApiKey')}
                </a>
            ),
        });
    } */

    // delete catalog
    if (isAdmin) {
        menu.push({
            key: 'sectionRemove',
            label: (
                <a onClick={this.sectionRemove} className={styles.settingRemove}>
                    <Icon type="icon edition-41" className={styles.settingIcon} />
                    {t('buttons.removeSection')}
                </a>
            ),
        });
    }

    if (inGroup && menu.length) {
        menu = [
            {
                key: '3',
                type: 'group',
                label: `${t('common.section')} «${section.get('name')}»`,
                children: menu,
            },
        ]
    }

    return menu;
}

export function sectionEdit() {
    const { t, sectionId } = this.props;

    modalsActions.openSectionEditModal(sectionId);
};

export function sectionAccess() {
    const sectionId = this.props.section.get('id');
    if (sectionId) {
        const isAdmin = checkAccessOnObject(RESOURCE_TYPES.SECTION, this.props.section, PRIVILEGE_CODES.ADMIN);
        const readOnly = !checkAccessOnObject(RESOURCE_TYPES.SECTION, this.props.section, PRIVILEGE_CODES.ACCESS);
        const object = { sectionId };
        modalsActions.openAccessModal({ object }, RESOURCE_TYPES.SECTION, { readOnly, isAdmin }, true);
    }
};

export function sectionSetId() {
    const { t, sectionId, loadingForModal } = this.props;
    promptModal({
        headerText: t('modals.apiKeys.sectionApiKeyConfirm.headerText'),
        defaultValue: sectionId,
        onOk: this.sectionSetIdCallback,
        okText: t('buttons.save'),
        cancelText: t('buttons.cancel'),
        promptHint: t('modals.apiKeys.promptHint'),
        loading: loadingForModal,
        validateFunc: validateApiKey,
        t,
    });
};
export async function sectionSetIdCallback(newKey) {
    const { section, history, t } = this.props;
    this.setState({ loadingForModal: true });
    try {
        const sectionId = section.get('id');

        // Не задано? Явно указываем null
        // => удаляем запись из recordIds и получаем числовой dbId как раньше
        newKey = _.isEmpty(_.trim(newKey)) ? null : newKey;

        const { id: newSectionId } = await apiActions.updateSection({ sectionId }, { id: newKey }).then((result) => {
            const realNewId = result.id || newKey;

            sectionActions.truncateSectionFromStore({ sectionId });
            history.push({
                pathname: `/section/${realNewId}`,
                search: _.get(history, ['location', 'search'], ''),
            });
        });
    } catch (e) {
        alert({
            headerText: t('message.saveError'),
            text: t('modals.setApiKeyErrors.onSaveError'),
            okText: t('modals.setApiKeyErrors.okText'),
        });
    } finally {
        this.setState({ loadingForModal: false });
    }
};

export function sectionRemove() {
    const { t, sectionId, history, location } = this.props;
    const sectionName = this.props.section.get('name');

    promptConfirm({
        value: sectionName,
        placeHolder: sectionName,
        headerText: t('modals.removeSectionConfirm.headerText'),
        text: (
            <span>
                {t('modals.removeSectionConfirm.firstText')}
                <br />
                {t('modals.removeSectionConfirm.secondText')}
            </span>
        ),
        okText: t('modals.removeSectionConfirm.okText'),
        cancelText: t('modals.removeSectionConfirm.cancelText'),
        onOk: () =>
            apiActions
                .deleteSection({ sectionId })
                .then(() => {
                    history.replace({
                        pathname: '/',
                        search: location ? location.search : '',
                    });
                }),
    });
};